module.exports = __webpack_public_path__ + "screenshots.796eb908f67c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/marketing/images/screenshots.png
// module id = ./src/app/marketing/images/screenshots.png
// module chunks = 21